var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutDialogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 40,
    stroke: "#F4F4F4",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4217 24.0055C40.8258 23.9706 41.223 24.103 41.5295 24.3817C41.8291 24.6534 41.9963 25.0366 41.9963 25.4477V62.5551C41.9963 62.9871 41.8082 63.3912 41.4738 63.6629C41.1463 63.9416 40.7144 64.053 40.2963 63.9764L25.1914 61.2871C24.5016 61.1686 24 60.5694 24 59.8657V26.7784C24 26.0329 24.5713 25.4059 25.3238 25.3432L40.4217 24.0055ZM39.1607 44.0014C39.1607 42.9075 38.6521 42.0227 38.032 42.0227C37.4119 42.0227 36.9103 42.9075 36.9103 44.0014C36.9103 45.0883 37.4119 45.9801 38.032 45.9801C38.6521 45.9801 39.1607 45.0883 39.1607 44.0014Z",
    fill: "#616E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9225 43.228L52.12 34.4633V39.0059H42.9512V47.3874H52.12V51.937L63.9225 43.228Z",
    fill: "#AAD4C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9102 44.0014C36.9102 45.0953 37.4118 45.9801 38.0388 45.9801C38.6589 45.9801 39.1606 45.0953 39.1606 44.0014C39.1606 42.9075 38.6589 42.0227 38.0388 42.0227C37.4118 42.0227 36.9102 42.9075 36.9102 44.0014Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0889 37.724V26.4092C51.0889 26.1166 50.9704 25.824 50.7614 25.6149C50.5524 25.4059 50.2598 25.2805 49.9672 25.2805H42.9512V27.5379H48.8385V37.724H51.0889Z",
    fill: "#616E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9512 60.4649V62.7223H49.9672C50.2598 62.7223 50.5524 62.6038 50.7614 62.3879C50.9704 62.1788 51.0889 61.8862 51.0889 61.5936V48.6067H48.8385V60.4649H42.9512Z",
    fill: "#616E7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDialogIcon);
export default __webpack_public_path__ + "static/media/logoutDialogIcon.9ac86da2c1599b4a3400b5e73ace7435.svg";
export { ForwardRef as ReactComponent };